import { useState, useEffect } from 'react';

export const useAnalysisDetection = (historyId, history, isStreaming, setProgressModal, startAnalysis, t, backgroundReconnect) => {
  // ✅ 중복 분석 방지: 한 번만 실행되도록 수정
  const [hasStartedAnalysis, setHasStartedAnalysis] = useState(false);
  
  // ✅ 새로운 분석 감지 및 즉시 progressModal 표시
  useEffect(() => {
    if (historyId && history.length > 0) {
      const targetHistory = history.find(h => h.id === historyId);
      
      // Resume에서 온 경우 체크
      const shouldStartFromResume = window.shouldStartAnalysisOnLoad;
      
      // 🚨 백그라운드 재연결 중이면 새로운 분석 시작하지 않음
      if (backgroundReconnect?.isReconnecting || backgroundReconnect?.backgroundProcessing) {
        console.log('🔄 [AnalysisDetection] 백그라운드 재연결 중이므로 새로운 분석 시작 생략', {
          isReconnecting: backgroundReconnect?.isReconnecting,
          backgroundProcessing: backgroundReconnect?.backgroundProcessing
        });
        return;
      }
      
      // 🔐 이미 분석이 완료된 경우 새로운 분석 시작 방지
      if (targetHistory) {
        // 분석 완료 조건 확인 (status가 'active'인 경우 무조건 완료로 간주)
        const hasCompletedAnalysis = targetHistory.status === 'active' || (
          targetHistory.summary && targetHistory.summary.trim().length > 0
        ) || (
          targetHistory.chapters && Array.isArray(targetHistory.chapters) && targetHistory.chapters.length > 0
        );
        
        if (hasCompletedAnalysis) {
          console.log('🛡️ [AnalysisDetection] 분석이 이미 완료된 히스토리 - 새로운 분석 시작 방지:', {
            historyId,
            status: targetHistory.status,
            hasSummary: !!targetHistory.summary,
            hasChapters: !!targetHistory.chapters,
            hasChunkSummaries: !!targetHistory.chunk_summaries
          });
          return;
        }
        
        // 🎯 백그라운드 재연결 로직에서 모든 케이스를 처리하므로 fromNotification 파라미터 처리 제거
      }
      
      // analyzing 상태이고 아직 스트리밍이 시작되지 않은 경우 = 새로운 분석
      // 또는 Resume에서 온 경우
      if (targetHistory && 
          ((targetHistory.status === 'analyzing' && !isStreaming && !hasStartedAnalysis) || 
           (shouldStartFromResume && !hasStartedAnalysis))) {
        
        console.log('🚀 [AnalyzePage] 새로운 분석 감지 - 즉시 progressModal 표시:', {
          historyId,
          status: targetHistory.status,
          isStreaming,
          shouldStartFromResume
        });
        
        // ✅ 즉시 progressModal 표시 (분석 작업 시작 전에)
        setProgressModal({
          open: true,
          currentMessage: t('common.startingAnalysis')
        });
        
        // ✅ 중복 방지 플래그 설정
        setHasStartedAnalysis(true);
        
        // Resume 플래그 정리
        if (shouldStartFromResume) {
          window.shouldStartAnalysisOnLoad = false;
          window.resumeFromHistoryId = null;
        }
        
        // ✅ 백그라운드에서 분석 시작 (약간의 지연으로 모달이 먼저 렌더링되도록)
        // try-catch로 에러 처리 추가
        setTimeout(async () => {
          try {
            await startAnalysis(targetHistory);
          } catch (error) {
            console.error('[AnalyzePage] startAnalysis 에러:', error);
            // 에러 발생 시 progressModal 닫기
            setProgressModal(prev => ({ ...prev, open: false }));
          }
        }, 100);
      }
    }
  }, [historyId, history.length, isStreaming, hasStartedAnalysis, setProgressModal, startAnalysis, t, backgroundReconnect]);

  return {
    hasStartedAnalysis,
    setHasStartedAnalysis
  };
}; 